import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PushPipe } from '@ngrx/component';
import {
    Avatar,
    AvatarDetailPopup,
    WdxAvatarModule,
} from '@wdx/shared/components/wdx-avatar';
import { WdxSpinnerModule } from '@wdx/shared/components/wdx-spinner';
import { WdxStopPropagationDirective } from '@wdx/shared/components/wdx-stop-propagation';
import { TranslateTokenisedStringPipe, WdxThemeColor } from '@wdx/shared/utils';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { Observable } from 'rxjs';
import { stringComparator } from '../../utils';

export interface AvatarCellRendererValue {
    avatars: Avatar[];
    label?: string;
    url?: string[];
    newTab?: boolean;
    badge?: {
        label: string;
        color?: WdxThemeColor;
    };
    linkClickCallback?: () => void;
}

export interface AvatarCellRendererParams {
    popupContent$(avatar: Avatar): Observable<AvatarDetailPopup>;
}

export const avatarCellRendererComparator = (
    valueA: AvatarCellRendererValue,
    valueB: AvatarCellRendererValue,
) =>
    stringComparator(
        valueA?.avatars?.[0]?.text || '',

        valueB?.avatars?.[0]?.text || '',
    );

export const AVATAR_CELL_RENDERER_COL_DEFS: ColDef = {
    width: 80,
    maxWidth: 95,
};

@Component({
    selector: 'wdx-ag-grid-avatar-cell-renderer',

    imports: [
        CommonModule,
        WdxAvatarModule,
        PushPipe,
        WdxSpinnerModule,
        WdxStopPropagationDirective,
        RouterModule,
        TranslateTokenisedStringPipe,
    ],
    templateUrl: './avatar-cell-renderer.component.html',
    styleUrls: ['./avatar-cell-renderer.component.scss'],
    host: { class: 'd-flex align-items-center h-100' },
})
export class AvatarCellRendererComponent implements ICellRendererAngularComp {
    public avatars?: Avatar[];
    public label?: string;
    public url?: string[];
    public newTab?: boolean;
    public badge?: {
        label: string;
        color?: WdxThemeColor;
    };
    public linkClickCallback?: () => void;

    public popupEnabled = false;
    public popupContent$?: Observable<AvatarDetailPopup>;
    private _popupContent$?: (avatar: Avatar) => Observable<AvatarDetailPopup>;

    public agInit(
        params: ICellRendererParams<any, AvatarCellRendererValue>,
    ): void {
        this.avatars = params.value?.avatars || [];
        this.label = params.value?.label;
        this.url = params.value?.url;
        this.newTab = params.value?.newTab;
        this.badge = params.value?.badge;
        this.linkClickCallback = params.value?.linkClickCallback;

        if (params.colDef?.cellRendererParams?.popupContent$) {
            this.popupEnabled = true;
            this._popupContent$ =
                params.colDef?.cellRendererParams?.popupContent$;
        }
    }

    public refresh(
        params: ICellRendererParams<any, AvatarCellRendererValue>,
    ): boolean {
        this.agInit(params);
        return true;
    }

    public avatarClicked(avatar: Avatar) {
        if (this._popupContent$) {
            this.popupContent$ = this._popupContent$(avatar);
        }
    }
}
